import styled from '@emotion/styled';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { focusRing } from '@/shared/design-system';

const DISABLED_CHILD = '& > :disabled, & > [data-disabled], & > [aria-disabled="true"]';
const HAS_DISABLED_CHILD =
  '&:has(> :disabled), &:has(> [data-disabled]), &:has(> [aria-disabled="true"])';

const TriggerSpan = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: theme.radius[8],
  ...focusRing(theme, { inset: false }),
  // A disabled form control is a hit target that dispatches no pointer event and
  // lets none bubble, so the wrapper never sees the hover that opens the reason.
  [DISABLED_CHILD]: { pointerEvents: 'none' },
  [HAS_DISABLED_CHILD]: { cursor: 'not-allowed' },
}));

export type DeniedReasonTriggerProps = ComponentPropsWithoutRef<'span'> & {
  denied?: boolean;
};

export const DeniedReasonTrigger = forwardRef<HTMLSpanElement, DeniedReasonTriggerProps>(
  ({ denied = false, tabIndex, ...rest }, ref) => (
    <TriggerSpan ref={ref} tabIndex={tabIndex ?? (denied ? 0 : undefined)} {...rest} />
  ),
);

DeniedReasonTrigger.displayName = 'DeniedReasonTrigger';
